module.exports = __webpack_public_path__ + "assets/images/ios_first_install-7955535d2de9b656e0b02fed365974b0.mp4";